import React, { CSSProperties } from 'react';

export const SimpleQuestionMark: React.FC<{ style?: CSSProperties }> = (style = {}) => (
  <div
    style={{
      cursor: 'pointer',
      borderRadius: '50%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: ' center',
      width: '20px',
      height: '20px',
      fontWeight: 'bold',
      fontSize: 'normal',
      border: '1px solid #888',
      color: '#888',
      marginLeft: '5px',
      ...style,
    }}
  >
    ?
  </div>
);

export default SimpleQuestionMark;
